// dependency-graph-ignore-file
import { type Database } from '@databases/model/database';

export function toggleLockStructure(ydb: Database, newValue: boolean): void {
  ydb.mutate((db) => {
    db.isLocked = newValue;
  });
}
